module.exports = new __parcel__URL__("Trade.cf66312c.svg").toString();